"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../../shared-types/enums");
const FIRST_NAME_LENGTH_MIN = 1;
const FIRST_NAME_LENGTH_MAX = 150;
const LAST_NAME_LENGTH_MIN = 1;
const LAST_NAME_LENGTH_MAX = 150;
exports.requestSchema = zod_1.z.object({
    accountType: enums_1.accountTypeEnum,
    email: zod_1.z.string().email(),
    firstName: zod_1.z.string().min(FIRST_NAME_LENGTH_MIN).max(FIRST_NAME_LENGTH_MAX),
    language: enums_1.languageEnum,
    lastName: zod_1.z.string().min(LAST_NAME_LENGTH_MIN).max(LAST_NAME_LENGTH_MAX),
    country: zod_1.z.string(),
    locationLevel1: zod_1.z.string().optional().nullable(),
    phoneNumber: zod_1.z.string().optional().nullable(),
    smsNumber: zod_1.z.string().optional().nullable(),
    units: enums_1.customerUnitEnum,
});
exports.path = '/admin-invite-user';
//# sourceMappingURL=index.js.map